<div class="main-container">
  <div class="grid-container" id="8594report-grid-container" style="height: calc(100vh - 124px);">
    <div class="top-toolbar">
      <div class="toolbar-actions">
        @if (taxyearLoaded) {
<ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYearItem" (onSelect)="onTaxYearChanged($event)">
  @for (item of taxYearItems; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item" [ariaLabel]="setTaxYearAriaLabel(item)" (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
}
        <!-- <p-select *ngIf="scenarioLoaded" class="mr-2" [options]="scenarios" optionLabel="text" [(ngModel)]="scenario"
          (onChange)="onScenarioChange()">
        </p-select> -->
        <gtw-df-me-dropdown class="top-filter-select me-dropdown-label" [customActionCode]="32136"
                            (selectedMes)="selectedMeChanged($event)">
        </gtw-df-me-dropdown>
        <ap-button [compact]="true" [btnType]="'primary'" [label]="'Filter'" (onClick)="loadReport()"></ap-button>
        <span class="toolbar-export" (click)="exportToExcel()">
          <span class="Appkit4-icon icon-save-outline"></span>
          <span>Export to Excel</span>
        </span>
      </div>
    </div>

    <div class="dst-mat-grid-layout">
      @if (loading) {
        <div class="dst-mat-grid-loading">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      }
      <div class="dst-mat-grid">
        <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort #matSort="matSort"
               (matSortChange)="onMatSortChange()" class="dst-mat-table">

          <ng-container matColumnDef="STATEMENTID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[0])">{{ cols[0].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[0])">
              <a href="javascript:void(0);" (click)="showViewUpdateStatement(rowData)">
                <span>{{ rowData.STATEMENTID }}</span>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="PROJECT_NAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[1])">{{ cols[1].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[1])">
              <span>{{ rowData.PROJECT_NAME }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[2])">{{ cols[2].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[2])">
              <span>{{ rowData.PRIMARYLEID }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYENTITY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[3])">{{ cols[3].header }}</th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[3])">
              <span>{{ rowData.PRIMARYENTITY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PURCHASERORSELLER_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[4])">{{ cols[4].header }}</th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[4])">
              <span>{{ rowData.PURCHASERORSELLER_VAL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="FILING_GROUP">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[5])">{{ cols[5].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[5])">
              <span>{{ rowData.FILING_GROUP }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="SECONDARYLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[6])">{{ cols[6].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[6])">
              <span>{{ rowData.SECONDARYLEID }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="EINOFOTHERPARTY1_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[7])">{{ cols[7].header }}</th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[7])">
              <span>{{ rowData.EINOFOTHERPARTY1_VAL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="EIN_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[8])">{{ cols[8].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[8])">
              <span>{{ rowData.EIN_VAL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="ADDRESSOFOTHERPARTY1_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[9])">{{ cols[9].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[9])">
              <span>{{ rowData.ADDRESSOFOTHERPARTY1_VAL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="ADDRESSOFOTHERPARTY2_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[10])">{{ cols[10].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[10])">
              <span>{{ rowData.ADDRESSOFOTHERPARTY2_VAL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="CITYOFOTHERPARTY_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[11])">{{ cols[11].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[11])">
              <span>{{ rowData.CITYOFOTHERPARTY_VAL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="STATE_US_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[12])">{{ cols[12].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[12])">
              <span>{{ rowData.STATE_US_VAL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="COUNTRY1_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[13])">{{ cols[13].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[13])">
              <span>{{ rowData.COUNTRY1_VAL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="ZIPCODE5_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[14])">{{ cols[14].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[14])">
              <span>{{ rowData.ZIPCODE5_VAL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="DATEOFSALE_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[15])">{{ cols[15].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[15])">
              <span>{{ rowData.DATEOFSALE_VAL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="TOTALSALESPRICE_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[16])">{{ cols[16].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[16])">
              <span gtwLineSplitter [inputString]="rowData.TOTALSALESPRICE_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.TOTALSALESPRICE_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS1FMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[17])">{{ cols[17].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[17])">
              <span gtwLineSplitter [inputString]="rowData.CLASS1FMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS1FMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS2FMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[18])">{{ cols[18].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[18])">
              <span gtwLineSplitter [inputString]="rowData.CLASS2FMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS2FMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS3FMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[19])">{{ cols[19].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[19])">
              <span gtwLineSplitter [inputString]="rowData.CLASS3FMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS3FMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS4FMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[20])">{{ cols[20].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[20])">
              <span gtwLineSplitter [inputString]="rowData.CLASS4FMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS4FMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS5FMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[21])">{{ cols[21].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[21])">
              <span gtwLineSplitter [inputString]="rowData.CLASS5FMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS5FMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS6N7FMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[22])">{{ cols[22].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[22])">
              <span gtwLineSplitter [inputString]="rowData.CLASS6N7FMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS6N7FMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="TOTALFMV_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[23])">{{ cols[23].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[23])">
              <span gtwLineSplitter [inputString]="rowData.TOTALFMV_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.TOTALFMV_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS1ASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[24])">{{ cols[24].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[24])">
              <span gtwLineSplitter [inputString]="rowData.CLASS1ASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS1ASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS2ASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[25])">{{ cols[25].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[25])">
              <span gtwLineSplitter [inputString]="rowData.CLASS2ASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS2ASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS3ASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[26])">{{ cols[26].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[26])">
              <span gtwLineSplitter [inputString]="rowData.CLASS3ASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS3ASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS4ASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[27])">{{ cols[27].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[27])">
              <span gtwLineSplitter [inputString]="rowData.CLASS4ASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS4ASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS5ASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[28])">{{ cols[28].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[28])">
              <span gtwLineSplitter [inputString]="rowData.CLASS5ASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS5ASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS6N7ASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[29])">{{ cols[29].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[29])">
              <span gtwLineSplitter [inputString]="rowData.CLASS6N7ASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS6N7ASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="TOTALASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[30])">{{ cols[30].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[30])">
              <span gtwLineSplitter [inputString]="rowData.TOTALASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.TOTALASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CHOICE204A_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[31])">{{ cols[31].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[31])">
              <span>{{ rowData.CHOICE204A_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CHOICE204B_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[32])">{{ cols[32].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[32])">
              <span>{{ rowData.CHOICE204B_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CHOICE204C_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[33])">{{ cols[33].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[33])">
              <span>{{ rowData.CHOICE204C_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="TAXYEAR1_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[34])">{{ cols[34].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[34])">
              <span>{{ rowData.TAXYEAR1_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="FORM1_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[35])">{{ cols[35].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[35])">
              <span>{{ rowData.FORM1_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS1PPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[36])">{{ cols[36].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[36])">
              <span gtwLineSplitter [inputString]="rowData.CLASS1PPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS1PPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS2PPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[37])">{{ cols[37].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[37])">
              <span gtwLineSplitter [inputString]="rowData.CLASS2PPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS2PPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS3PPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[38])">{{ cols[38].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[38])">
              <span gtwLineSplitter [inputString]="rowData.CLASS3PPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS3PPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS4PPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[39])">{{ cols[39].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[39])">
              <span gtwLineSplitter [inputString]="rowData.CLASS4PPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS4PPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS5PPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[40])">{{ cols[40].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[40])">
              <span gtwLineSplitter [inputString]="rowData.CLASS5PPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS5PPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS6N7PPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[41])">{{ cols[41].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[41])">
              <span gtwLineSplitter [inputString]="rowData.CLASS6N7PPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS6N7PPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="TOTALPPR_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[42])">{{ cols[42].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[42])">
              <span gtwLineSplitter [inputString]="rowData.TOTALPPR_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.TOTALPPR_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS1INCDEC_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[43])">{{ cols[43].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[43])">
              <span gtwLineSplitter [inputString]="rowData.CLASS1INCDEC_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS1INCDEC_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS2INCDEC_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[44])">{{ cols[44].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[44])">
              <span gtwLineSplitter [inputString]="rowData.CLASS2INCDEC_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS2INCDEC_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS3INCDEC_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[45])">{{ cols[45].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[45])">
              <span gtwLineSplitter [inputString]="rowData.CLASS3INCDEC_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS3INCDEC_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS4INCDEC_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[46])">{{ cols[46].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[46])">
              <span gtwLineSplitter [inputString]="rowData.CLASS4INCDEC_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS4INCDEC_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS5INCDEC_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[47])">{{ cols[47].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[47])">
              <span gtwLineSplitter [inputString]="rowData.CLASS5INCDEC_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS5INCDEC_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS6N7INCDEC_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[48])">{{ cols[48].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[48])">
              <span gtwLineSplitter [inputString]="rowData.CLASS6N7INCDEC_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS6N7INCDEC_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS1RASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[49])">{{ cols[49].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[49])">
              <span gtwLineSplitter [inputString]="rowData.CLASS1RASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS1RASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS2RASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[50])">{{ cols[50].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[50])">
              <span gtwLineSplitter [inputString]="rowData.CLASS2RASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS2RASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS3RASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[51])">{{ cols[51].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[51])">
              <span gtwLineSplitter [inputString]="rowData.CLASS3RASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS3RASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS4RASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[52])">{{ cols[52].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[52])">
              <span gtwLineSplitter [inputString]="rowData.CLASS4RASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS4RASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS5RASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[53])">{{ cols[53].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[53])">
              <span gtwLineSplitter [inputString]="rowData.CLASS5RASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS5RASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="CLASS6N7RASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[54])">{{ cols[54].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[54])">
              <span gtwLineSplitter [inputString]="rowData.CLASS6N7RASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.CLASS6N7RASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="TOTALRASP_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[55])">{{ cols[55].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[55])">
              <span gtwLineSplitter [inputString]="rowData.TOTALRASP_VAL" [sepearator]="','" [formatter]="'decimal'">{{ rowData.TOTALRASP_VAL }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="REASONINCDEC_VAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[56])">{{ cols[56].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[56])">
              <span>{{ rowData.REASONINCDEC_VAL }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 45px;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 70px;"></tr>
        </table>
      </div>
    </div>
  </div>
</div>

@if (showModalViewer) {
<dst-disc-modal-viewer [rowObject]="activeRow" (afterModalClosed)="afterModalClosed()">
</dst-disc-modal-viewer>
}
